export const LEVEL_UP_LINT_CODES = [
    // The legacy adapter's six (two conversion-only).
    "EMPTY_TIER",
    "TIER_WITHOUT_FRAMEWORK",
    "LINK_WITHOUT_TITLE",
    "METRIC_MULTIPLE_GREEN_RIBBON",
    "POINTS_NOT_D_PLUS_I",
    "UNKNOWN_FRAMEWORK",
    // Package-only.
    "NO_PILLARS",
    "NO_METRICS",
    "METRIC_WITHOUT_TIER_1",
    "MULTIPLE_FRAMEWORK_VALUES",
];
/**
 * The four problems only the publish RPC (`level_up_publish_version`) reports
 * in its `PUBLISH_INVALID` list — the package schema refuses them before a
 * save, so {@link lintLevelUpPackage} never emits them. The single list the
 * API, the web and the tests use.
 */
export const LEVEL_UP_PUBLISH_ONLY_CODES = [
    "TIERS_NOT_CONTIGUOUS",
    "TIER_0_SCORES",
    "BADGE_BANDS_INVALID",
    "TIER_NAME_MISSING",
];
export const LEVEL_UP_LINT_SEVERITIES = ["blocker", "warning", "info"];
/** Lint a package, in package order: package-level items first, then per metric (metric items, then its tiers). */
export function lintLevelUpPackage(pkg) {
    const items = [];
    if (pkg.pillars.length === 0)
        items.push({ code: "NO_PILLARS", severity: "blocker" });
    if (pkg.metrics.length === 0)
        items.push({ code: "NO_METRICS", severity: "blocker" });
    for (const link of pkg.metadata.helpLinks) {
        if (link.title === undefined)
            items.push({ code: "LINK_WITHOUT_TITLE", severity: "warning" });
    }
    for (const metric of pkg.metrics) {
        const metricKey = metric.key;
        // Tiers run 0..N with N ≥ 1 (the schema enforces 0..N; publishing needs a tier 1).
        if (!metric.tiers.some((t) => t.level === 1)) {
            items.push({ code: "METRIC_WITHOUT_TIER_1", severity: "blocker", metricKey });
        }
        for (const link of metric.links) {
            if (link.title === undefined)
                items.push({ code: "LINK_WITHOUT_TITLE", severity: "warning", metricKey });
        }
        const greenRibbon = new Set();
        const tierItems = [];
        for (const tier of metric.tiers) {
            const tierLevel = tier.level;
            const { greenRibbonPillars, impactValueChain } = tier.frameworks;
            for (const value of greenRibbonPillars)
                greenRibbon.add(value);
            for (const link of tier.howToLinks) {
                if (link.title === undefined)
                    tierItems.push({ code: "LINK_WITHOUT_TITLE", severity: "warning", metricKey, tierLevel });
            }
            if (tier.isEmpty)
                tierItems.push({ code: "EMPTY_TIER", severity: "info", metricKey, tierLevel });
            if (tierLevel >= 1 && greenRibbonPillars.length === 0 && impactValueChain.length === 0) {
                tierItems.push({
                    code: "TIER_WITHOUT_FRAMEWORK",
                    severity: tier.isEmpty ? "info" : "warning",
                    metricKey,
                    tierLevel,
                });
            }
            if (greenRibbonPillars.length > 1 || impactValueChain.length > 1) {
                tierItems.push({ code: "MULTIPLE_FRAMEWORK_VALUES", severity: "warning", metricKey, tierLevel });
            }
        }
        if (greenRibbon.size > 1) {
            items.push({ code: "METRIC_MULTIPLE_GREEN_RIBBON", severity: "warning", metricKey });
        }
        items.push(...tierItems);
    }
    return items;
}
/** True when any item blocks publishing. */
export function hasLevelUpLintBlocker(items) {
    return items.some((i) => i.severity === "blocker");
}
//# sourceMappingURL=lint.js.map